// Relative to the `/services` base URL used by both web and mobile
export const NP_AVAILABLE_TIMES_PATH = '/v2/calendar/available-times'
export const getNpScheduleSessionsPath = (userLyraId: string) => `/v2/calendar/${userLyraId}/schedule-sessions`

// TODO: replace with the provider the member is booking with once that data is available, or omit it for pooled scheduling
export const TEMP_NP_PROVIDER_LYRA_ID = '9f6c9126-6116-4cb4-a914-b80403eb8d25'

// TODO: remove once the available-times endpoint supports pooled scheduling (omitting providerLyraId)
export const TEMP_NP_IN_PERSON_PROVIDER_LYRA_ID = '2d8ad4d0-3fd7-454e-bb10-4bd1dfc7f650'

// TODO: remove once NP testing address collection is wired up
export const TEMP_NP_MEMBER_ADDRESS = '123 Market Street, San Francisco, CA'

// Booking window in days from today (the day the member is booking). Each appointment type will get its own window;
// clinical intake must be booked at least 7 days out and no more than 30 days out.
// TODO: add windows for testing sessions, which are relative to the prior appointment
export const NP_CLINICAL_INTAKE_BOOKING_WINDOW = { minDaysFromToday: 7, maxDaysFromToday: 30 }
